import { UseFormReturn } from "react-hook-form";
import TemplateTriggerForm from "features/Trigger/TemplateTrigger/Form";
import generateSchedulingSummary from "features/Trigger/helpers";
import { TriggerSchema } from "features/Trigger/TemplateTrigger/Form/schema";
import { TRIGGER_TYPE_TIMING } from "features/Trigger/TemplateTrigger/models";
import V2ModalForm, { FormWrapper } from "components/ModalForm/V2ModalForm";
import TriggerButton from "./TriggerButton";

interface SchedulingTriggerModalButtonProps {
  form: UseFormReturn<any>;
  fieldName: string;
  label?: string;
  disabled?: boolean;
  buttonVariant?: string;
  nullLabel?: string;
  timingOnly?: boolean;
  excludeTimeOfDay?: boolean;
  allowWeekendsFieldName?: string;
  allowWeekendsReadOnly?: boolean;
}

export default function SchedulingTriggerModalButton({
  fieldName,
  label,
  form,
  disabled = false,
  nullLabel = undefined,
  buttonVariant = "unstyled",
  timingOnly = false,
  excludeTimeOfDay = false,
  allowWeekendsFieldName,
  allowWeekendsReadOnly = false,
}: SchedulingTriggerModalButtonProps) {
  const {
    watch,
  } = form;
  const triggerWatch = watch(fieldName);
  const trigger = triggerWatch as TriggerSchema; // FIXME: Not able to get watch to appropriately type the resulting value, so casting for the moment. Should figure this out

  let descriptor = nullLabel ?? `No ${label}`;
  if (trigger && trigger.type === TRIGGER_TYPE_TIMING && trigger.data) {
    descriptor = generateSchedulingSummary({ field: fieldName, trigger });
  }

  const triggerButton = <TriggerButton trigger={trigger} descriptor={descriptor} buttonVariant={buttonVariant} disabled={disabled} />;

  return disabled ? (
    triggerButton
  ) : (
    <V2ModalForm
      modalHeader={label ?? "Sending At"}
      size="lg"
      includeCloseButton={false}
      onClose={() => form.trigger(fieldName)}
      renderButton={(onOpen) => (
        <TriggerButton
          trigger={trigger}
          descriptor={descriptor}
          buttonVariant={buttonVariant}
          disabled={disabled}
          onClick={onOpen}
        />
      )}
      renderForm={(onClose) => (
        <FormWrapper onClick={onClose}>
          <TemplateTriggerForm
            form={form}
            fieldName={fieldName}
            timingOnly={timingOnly}
            includeTimeOfDay={!excludeTimeOfDay}
            allowWeekendsFieldName={allowWeekendsFieldName}
            allowWeekendsReadOnly={allowWeekendsReadOnly}
          />
        </FormWrapper>
      )}
    />
  );
}
